import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { List } from 'immutable';
import { Observable } from 'rxjs';
import { v4 } from 'uuid';
import { onActions } from '../../utils/helpers/redux.helper';
import {
  ActionsEnum,
  batchMarkNotificationsAsSeen,
  dismissNotification,
  fetchNotifications,
  markNotificationAsRead,
  registerNotificationsPolling,
  unregisterNotificationsPolling,
} from './notification-data.actions';
import { Notification } from './notification.model';
import { NOTIFICATIONS_POLLING_INTERVAL } from './notification-data.data';

@Injectable()
export class NotificationDataDispatcher {
  constructor(private _store: Store<any>, private _actions: Actions) {}

  // TODO: handle pagination
  fetchNotifications(page?: number): Observable<Action> {
    const dispatchId = v4();

    this._store.dispatch(fetchNotifications(dispatchId));

    return onActions(
      this._actions,
      [
        ActionsEnum.FETCH_NOTIFICATIONS_SUCCESS,
        ActionsEnum.FETCH_NOTIFICATIONS_ERROR,
      ],
      dispatchId
    );
  }

  markNotificationAsRead(notification: Notification) {
    const dispatchId = v4();

    this._store.dispatch(markNotificationAsRead(dispatchId, notification));
  }

  batchMarkNotificationsAsSeen(notificationIds: List<string>) {
    const dispatchId = v4();

    this._store.dispatch(
      batchMarkNotificationsAsSeen(dispatchId, notificationIds)
    );
  }

  dismissNotification(notification: Notification): Observable<Action> {
    const dispatchId = v4();

    this._store.dispatch(dismissNotification(dispatchId, notification));

    return onActions(
      this._actions,
      [
        ActionsEnum.DISMISS_NOTIFICATION_SUCCESS,
        ActionsEnum.DISMISS_NOTIFICATION_ERROR,
      ],
      dispatchId
    );
  }

  registerNotificationsPolling(
    interval: number = NOTIFICATIONS_POLLING_INTERVAL
  ) {
    this._store.dispatch(registerNotificationsPolling(interval));
  }

  unregisterNotificationsPolling() {
    this._store.dispatch(unregisterNotificationsPolling());
  }
}
